import styled from 'styled-components';

export const EnrollmentContainer = styled.div`
    display: flex;
    padding: 24px 0;

    @media (max-width: 1200px) {
        flex-direction: column;
    }
`

export const EnrollmentMain = styled.div`
    flex: 1;
`

export const EnrollmentAside = styled.div`
    width: 360px;
    margin-left: 60px;

    @media (min-width: 1201px) {
        position: sticky;
        top: calc(var(--header-height) + 24px);
        align-self: flex-start;
        max-height: calc(100vh - var(--header-height) - 48px);
        overflow-y: auto;
    }

    @media (max-width: 1200px) {
        width: 100%;
        margin-left: 0;
        margin-bottom: 44px;
        margin-top: 44px;
    }
`

export const AsideBox = styled.div`
    background-color: var(--surface-2);
    border: 1px solid var(--color-border-dark);
    border-radius: 15px;
    overflow: hidden;
    padding: 24px 20px;
    color: var(--ink-inverse);
`

export const AsideBoxHeader = styled.div`
    margin-bottom: 32px;
    
    h5{
        margin: 0;
        font-size: 17px;
    }
`

export const AsideBoxBody = styled.div`
    .plan-links a {
        color: rgba(255, 255, 255, 0.78);
        text-decoration-color: rgba(255, 255, 255, 0.35);
        transition: color 200ms var(--ease-out);

        &:hover {
            color: var(--brand);
            text-decoration-color: var(--brand);
        }
    }
`

export const EnrollmentStepWrapper = styled.div`
    padding: 20px 0;
`

export const EnrollmentStepFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-top: 44px;
`

export const EnrollmentRadioGroup = styled.div`
    display: flex;
    margin: 20px -20px;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const EnrollmentRadioBox = styled.div`
    flex: 1;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 24px 20px;
    cursor: pointer;
    margin: 0 20px;
    position: relative;
    transition: border-color .3s, box-shadow .3s, top .3s;
    top: 0;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            top: -3px;
            border-color: var(--brand);
            box-shadow: 0 8px 24px rgba(112, 198, 24, 0.18);
        }
    }

    & > div {
        display: flex;
        align-items: flex-start;
        min-height: 2.5em;

        svg {
            flex-shrink: 0;
            margin-top: 0.2em;
        }

        span {
            flex: 1;
            min-width: 0;
            line-height: 1.25;
            overflow-wrap: break-word;
            word-break: normal;
        }
    }

    p {
        margin: 8px 0 0;
        font-size: 14px;
        line-height: 1.35;
        color: #666;
    }

    @media (max-width: 768px) {
        margin-top: 8px;
        margin-bottom: 8px;

        & > div {
            min-height: 0;
        }
    }
`

export const EnrollmentFormRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 12px -20px;
    row-gap: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        margin-top: 8px;
        margin-bottom: 8px;
        row-gap: 16px;
    }
`

interface EnrollmentFormColProps {
    full?: boolean;
}

export const EnrollmentFormCol = styled.div<EnrollmentFormColProps>`
    flex: ${({ full }) => full ? '0 0 100%' : '0 0 50%'};
    padding: 0 20px 4px;

    .react-datepicker-wrapper input[type="text"] {
        width: 100%;
        height: 38px;
        padding: 0 11px;
        border: 1px solid #ced4da;
        border-radius: 4px;
    }

    .dropdown button{
        width: 100%;
        border: 1px solid #ced4da;
    }

    .checkbox-item{
        padding-left: 0;
        padding-right: 0;
    }

    @media (max-width: 768px) {
        flex: 0 0 100%;
    }
`

export const EnrollmentAddressWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 32px;
    background-color: #fafafa;
    padding: 20px 24px;
    border-radius: 12px;
    border: 1px solid #ddd;
    font-size: 15px;
    line-height: 1.4;

    > div {
        min-width: 0;
        flex: 1;
    }

    b {
        font-weight: 500;
        margin-right: 6px;
    }

    p {
        margin: 6px 0;
        overflow-wrap: anywhere;
        word-break: break-word;
    }

    .address-line {
        font-size: 18px;
        line-height: 1.35;
    }

    a {
        display: inline-block;
        flex-shrink: 0;
        text-decoration: none;
        margin-left: 8px;
        white-space: nowrap;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 16px 18px;
        font-size: 14px;
        gap: 12px;

        .address-line {
            font-size: 16px;
        }

        a {
            margin-left: 0;
        }
    }
`

export const CreditCheckSection = styled.div`
    background-color: #fafafa;
    padding: 24px 32px;
    border-radius: 12px;
    border: 1px solid #ddd;
    margin: 24px 0;

    h5 {
        margin-bottom: 24px;
    }

    p {
        color: #666;
        font-size: 13px;
        line-height: 1.45;
    }

    p b,
    p strong {
        font-weight: 700;
        font-size: 15px;
        color: #333;
    }
`

export const ReviewWrapper = styled.div`
    h5 {
        margin: 20px 0 -8px;
        padding: 0 20px;
        font-size: 18px;
    }

    .checkbox-row {
        margin: 8px 0;
    }

    .checkbox-row .checkbox-item span {
        font-size: 13px;
        line-height: 1.35;
        color: #555;
    }
`

export const ReviewBlock = styled.div`
    padding: 8px 20px;

    h6 {
        margin-bottom: 12px;
        padding-bottom: 8px;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #666;
        border-bottom: 1px solid #eee;
    }
`

export const ReviewRow = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    margin: 8px 0;
    font-size: 15px;
    line-height: 1.4;

    label {
        margin: 0;
        color: #666;
        font-weight: 400;
        flex-shrink: 0;
    }

    span {
        text-align: right;
        overflow-wrap: anywhere;
    }
`

export const ReviewDisclaimer = styled.div`
    margin-top: 24px;
    font-size: 13px;
    line-height: 1.35;
    color: #666;
    font-weight: 300;
    padding: 0 20px;
`

export const PlanSummaryPromote = styled.div`
    padding-top: 16px;
    font-size: 12px;
    line-height: 1.35;
    color: rgba(255, 255, 255, 0.55);
`

export const PasswordInputWrap = styled.div`
    position: relative;

    .form-control {
        padding-right: 44px;
    }

    .ssn-mask-overlay {
        position: absolute;
        left: 1px;
        right: 44px;
        top: 1px;
        bottom: 1px;
        z-index: 0;
        display: flex;
        align-items: center;
        padding: 0.375rem 0.75rem;
        border-radius: var(--radius-field);
        background: #ffffff;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1rem;
        line-height: 1.5;
        letter-spacing: 0.06em;
        pointer-events: none;
        white-space: pre;
        overflow: hidden;
    }

    .ssn-mask-overlay [data-kind='filled'] {
        color: #212529;
    }

    .ssn-mask-overlay [data-kind='empty'] {
        color: #c5c5c5;
    }

    .ssn-mask-overlay [data-kind='space'] {
        color: transparent;
    }

    .ssn-secure-input.form-control {
        position: relative;
        z-index: 1;
        color: transparent !important;
        caret-color: #212529;
        background-color: transparent !important;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        letter-spacing: 0.06em;
    }
`

export const PasswordToggleBtn = styled.button`
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    width: 44px;
    border: 0;
    background: transparent;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    img {
        width: 20px;
        height: 20px;
        display: block;
        opacity: 0.55;
        pointer-events: none;
    }

    &:hover img {
        opacity: 0.85;
    }
`

export const PlanSummaryList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

interface PlanSummaryRowProps {
    narrow?: boolean;
}

export const PlanSummaryRow = styled.div<PlanSummaryRowProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: ${({ narrow }) => { return narrow ? '4px 0' : '0' }};
    font-size: 14px;
    line-height: 1.2;
    min-height: 28px;

    label {
        font-weight: 500;
        margin: 0;
    }

    span {
        font-size: 15px;
    }

    b {
        font-size: 20px;
        font-weight: 600;
    }

    .plan-highlight {
        color: var(--brand);
        font-size: 24px;
        font-weight: 600;
        line-height: 1.2;
    }
`